exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app-breadcrumb.el-breadcrumb[data-v-c0b1db24]{display:inline-block;font-size:14px;line-height:50px;margin-left:10px}.app-breadcrumb.el-breadcrumb .no-redirect[data-v-c0b1db24]{color:#97a8be;cursor:text}\n", ""]);

